// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"cad8336c","715":"50ca7c25","787":"6195eb37"}[chunkId] + ".chunk.js";
};